module.exports = "/_next/static/images/f36c4ac47f4d7ea5ca32188c40633ddf-credit-card-autonomy@0.5x.png.webp";